<div class="signup-container">
  <h4
    class="heading font-bureau font-medium"
    [class.verify-screen]="signupSuccess()"
  >
    Sign up for NeuralOps
  </h4>
  <form [formGroup]="form" class="signup-form auth-form-wrapper">
    @if (signupSuccess()) {
      <div class="verification-message font-geist font-normal">
        Please enter the 6-digit code sent to: {{this.form.controls['email'].value || ''}}
      </div>
    }

    <app-text-input
      [parentFormGroup]="form"
      controlName="email"
      [label]="!signupSuccess() ? 'Email' : ''"
      [error]="errorMessages['email']"
      (checkForErrors)="checkForErrors($event)"
    />

    @if (!signupSuccess()) {
      <app-password-input
        [parentFormGroup]="form"
        controlName="password"
        label="Password"
        [error]="errorMessages['password']"
        (checkForErrors)="checkForErrors($event)"
      />

      <app-password-input
        [parentFormGroup]="form"
        controlName="confirmPassword"
        label="Confirm password"
        [error]="errorMessages['confirmPassword']"
        [isConfirmPassword]="true"
        (checkForErrors)="checkForErrors($event)"
      />
    } @else {
      <app-otp-input
        [parentFormGroup]="otpForm"
        controlName="otp"
        label="Verification Code"
        [error]="errorMessages['otp']"
        (checkForErrors)="checkForOtpErrors($event)"
      />
    }

    <app-primary-button
      [isLoading]="(isLoading$ | async)"
      [isDisabled]="(isLoading$ | async)"
      (handleClick)="submit()"
    >
      {{ (signupSuccess() ? 'VERIFY CODE' : 'CREATE ACCOUNT') }}
    </app-primary-button>

    @if (signupSuccess()) {
      <app-secondary-button
        [isLoading]="isResendOtpLoading$ | async"
        [isDisabled]="(isResendOtpLoading$ | async) || countdownTimer > 0"
        (handleClick)="resendOtp()"
      >
        {{ getResendButtonText() }}
      </app-secondary-button>
      <div
        class="start-over font-geist font-medium"
        (click)="startOver()"
      >
        Start Over
      </div>
    }
  </form>

  @if (!signupSuccess()) {
    <div class="terms-text font-geist font-regular">
      By registering, you agree to NeuralOps
      <a href="/terms-of-service" class="link font-medium">Terms of Service</a> and
      <a href="/privacy-policy" class="link">Privacy Policy</a>
    </div>

    <div class="signin-prompt font-geist font-regular">
      Already have an account? <a href="/login" class="link font-medium">Sign In</a>
    </div>
  }

  <div class="copyright font-geist font-regular">
    © 2025 NeuralOps. All rights reserved.
  </div>
</div>
